export const habaContactForm = {
  habaContactForm: {
    success: {
      title: 'Vielen Dank für Ihre Nachricht',
      txt: 'Die Antwort auf ihre Anfrage erhalten Sie per E-Mail an folgende Adresse',
    },
    messages: {
      notValidError: 'Ungültige Eingaben',
      serverError: 'Es ist ein unbekannter Fehler aufgetreten',
    },
    form: {
      legend: 'Kontaktformular',
      reason: {
        label: 'Grund ihrer Anfrage',
        error: 'Bitte Grund ihrer Anfrage auswählen',
      },
      reference: {
        label: 'Betreff',
        error: 'Bitte Betreff eingeben',
      },
      file: {
        label: 'Datei hochladen..',
        error: 'Bitte eine Datei auswählen',
      },
      message: {
        label: 'Ihre Nachricht',
        error: 'Bitte geben sie ihre Nachricht ein',
      },
      isInstitution: {
        true: {
          label: 'Institution',
        },
        false: {
          label: 'Firma',
        },
      },
      name: {
        label: 'Name',
        error: 'Bitte Name eingeben',
      },
      customerNumber: {
        label: 'Kundennummer (optional)',
        error: 'Bitte Kundennummer eingeben',
      },
      orderNumber: {
        label: 'Bestellnummer (optional)',
        error: 'Bitte Bestellnummer eingeben',
      },
      street: {
        label: 'Straße',
        error: 'Bitte Straße eingeben',
      },
      houseNumber: {
        label: 'Hausnummer',
        error: 'Bitte Hausnummer eingeben',
      },
      postcode: {
        label: 'PLZ',
        error: 'Bitte PLZ eingeben',
      },
      location: {
        label: 'Ort',
        error: 'Bitte Ort eingeben',
      },
      country: {
        label: 'Land',
        error: 'Bitte Land auswählen',
      },
      email: {
        label: 'E-Mail Adresse',
        error: 'Bitte E-Mail Adresse auswählen',
      },
      isAgreed: {
        label: 'Die AGB und Datenschutzbestimmungen der Haba Familygroup habe ich gelesen.',
        error: '',
      },
      submit: 'Absenden',
    },
  },
};
